import React from 'react';
import { motion } from 'framer-motion';
interface ScrollButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export const ScrollButton: React.FC<ScrollButtonProps> = ({
  children,
  className = '',
  onClick
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-lg bg-brand-600 px-8 py-4 font-sans text-lg font-bold text-white shadow-md transition-all hover:bg-brand-700 hover:shadow-lg ${className}`} data-id="element-360">
      <span className="relative z-10 flex items-center gap-2" data-id="element-361">{children}</span>
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000 group-hover:translate-x-full" data-id="element-362" />
    </motion.button>;
};